import Application from '../Application';
import BaseView, { DomainModel3D } from './BaseView';
import GenericAssetView from './GenericAssetView';
import pc from '../ParametricCache';
import { BufferGeometry, Mesh } from 'three';
import { HookRack } from '../domain';
import { blank } from '../MaterialFactory';
import { uvNormalize } from '../IIID';

export default class HookrackView extends BaseView {

    declare model: HookRack;
    panel: Mesh;
    hooks: GenericAssetView[];

    constructor(model: DomainModel3D, app: Application) {
        super(model, app);
        this.init();
    }

    make() {
        this.name = 'HookRack';
        this.userData.isHookRack = true;

        this.panel = new Mesh(new BufferGeometry(), blank);
        this.panel.castShadow = this.panel.receiveShadow = true;
        this.hooks = new Array(this.model.count);
        for(let i=0; i< this.model.count; i++) {
            this.hooks[i] = new GenericAssetView(this.model.hook, this.app);
            this.hooks[i].userData.suppressExport = false;
            this.add(this.hooks[i]);
        }

        this.add(this.panel);
    }

    bind() {
        const change = this.change.bind(this);
        this.model.bind('width', change);
        this.model.on('height', change);
        this.model.on('count', change);

        this.bindMaterial(this.panel, this.model.panel.material);
    }

    change() {
        this.updates.queue(
            async () => {
                let hooks: GenericAssetView[] = null;
                if(this.hooks.length != this.model.count) {
                    hooks = new Array(this.model.count);
                    for(let i=0; i< this.model.count; i++) {
                        this.hooks[i] = new GenericAssetView(this.model.hook, this.app);
                        this.hooks[i].userData.suppressExport = false;
                    }
                }

                let panel = await pc.make('FrontPanel',
                    this.model.panel.style,
                    this.model.width,
                    this.model.height,
                    (this.model.width / this.model.height) >= 1 ? 'horizontal' : 'vertical');
                uvNormalize(panel);

                return { panel, hooks };
            },
            ({panel, hooks}) => {
             
                this.panel.geometry = panel;
                panel.computeBoundingBox();
                const panelDepth =
                    panel.boundingBox.max.z - panel.boundingBox.min.z;

                if(hooks) {
                    for(let old of this.hooks) {
                        old.removeFromParent();
                    }
                    this.hooks = hooks;
                    for(let hook of hooks) {
                        this.add(hook);
                    }
                }

                if((this.model.width / this.model.height) >= 1) {
                    const space = this.model.width / this.model.count;
                    for(let i=0; i < this.hooks.length; i++) {
                        this.hooks[i].position.set(
                            space/2 + space*i,
                            this.model.height / 2,
                            panelDepth);
                    }
                } else {
                    const space = this.model.height / this.model.count;
                    for(let i=0; i < this.hooks.length; i++) {
                        this.hooks[i].position.set(
                            this.model.width / 2,
                            space/2 + space*i,
                            panelDepth);
                    }
                }

            });
    }
}
